<template>
  <el-select ref="customer" v-model="selected" filterable v-on:keyup.native.enter="enter" v-loading="loading"
    :multiple="multiple" clearable :size="size" placeholder="Selecione  uma opção" @change="update()" remote collapse-tags
    :remote-method="search">
    <el-option v-for="row of tableData" :key="row.id" :label="row.name" :value="row.id"></el-option>
  </el-select>
</template>

<script>
import { CustomerService } from "@/services/customers/customers.services";
export default {
  name: "CustomerList",
  data: function () {
    return {
      tableData: [],
      selected: "",
      loading: false,
    };
  },
  props: {
    current: String,
    multiple: false,
    customer: '',
    size: "",
  },
  watch: {
    current() {
      const vm = this;
      if (vm.$props.current) {
        vm.selected = vm.$props.current;
      }
    },
    customer() {
      const vm = this;
      vm.fetchCustomers();
    },
  },
  methods: {
    focus() {
      this.$refs.customer.$el.getElementsByTagName('input')[0].focus();
    },
    enter() {
      this.$emit("enter");
    },
    search(query) {
      this.fetchCustomers(query);
    },
    fetchCustomers(query) {
      const vm = this;
      vm.loading = true;
      setTimeout(() => {
        if (vm.$props.current && !query) {
          CustomerService.get(vm.$props.current)
            .then((response) => {
              vm.tableData.push(response);
              vm.selected = vm.$props.current;
            })
            .catch((error) => {
              this.$message({ type: "error", message: error });
            }).finally(() => vm.loading = false)
        } else if (vm.customer) {
          CustomerService.license(vm.customer)
            .then((response) => {
              vm.tableData = response.records;
            })
            .catch((error) => {
              this.$message({ type: "error", message: error });
            }).finally(() => vm.loading = false)
        } else {
          CustomerService.select(50, 1, '1', query || '')
            .then((response) => {
              vm.tableData = response.records;
            })
            .catch((error) => {
              this.$message({ type: "error", message: error });
            }).finally(() => vm.loading = false)
        }
      }, 500);
    },
    update() {
      const vm = this;
      const customerNameList = vm.multiple
        ? vm.selected.map(x => {
          const customerData = vm.tableData.find(y => y.id === x);
          return customerData.name;
        })
        : vm.tableData.find(y => y.id === vm.selected).name
      vm.$emit("input", vm.selected);
      vm.$emit("selected", vm.selected, customerNameList);
    },
  },
  mounted() {
    const vm = this;
    vm.fetchCustomers();
  },
};
</script>